import React, { useEffect } from 'react';
import { AppContext } from '../../App';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { labels } from '../../data/labels';
import { setTabLayerMobileHeight } from '../../utils/sport-effects';
import AdviceToReachBonusContainer from '../AdviceToReachBonusContainer';

function getAmount(coupon) {
    let amount = 0;
    if (coupon.selectedContainer === 'singlebets') {
    	amount = coupon.amountSingle;
    } else if (coupon.selectedContainer === 'multibets') {
    	amount = coupon.amountMulti;
    }
    const conf = getConfiguration();
    return getCurrencyValue(amount, conf.cs.m, conf.cs.nd, conf.cs.ct);
}

function BetslipBottomBar(props) {
    const appContext = React.useContext(AppContext);
    const betslipContext = React.useContext(BetslipContext);
    const betslipData = betslipContext.getBetslipData();
    const conf = getConfiguration();

    useEffect(function() {
        setTabLayerMobileHeight();
    });
    
    if (!betslipData || betslipContext.getCouponSelectionsNum() === 0 || appContext.showBetslip) {
        return null;
    }
    
    const couponKey = betslipData.selectedCoupon;
    const coupon = betslipData.coupons[couponKey];

    if(appContext.location.current ==='checkbet' || appContext.showCheckBet || appContext.location.current ==='checksystembets' || appContext.showCheckSystemBets || appContext.location.current ==='mybets' || appContext.showMyBets ){
        return <></>;
    }
    
    const showAdvise = coupon.selectedContainer === 'multibets' && betslipContext.toGetBonusAdvise && betslipContext.toGetBonusAdvise.showAdvise;

    let maxPaidPotentialWinning = null;
    
    if(coupon.selectedContainer === 'systembets' ){
    	if(conf.sbmw !== 0 && conf.mwspw){
    		if(coupon.potentialWinning > conf.sbmw){
    			maxPaidPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    else{
    	if(conf.mbmw !== 0 && conf.mwmpw){
    		if(coupon.potentialWinning > conf.mbmw){
    			maxPaidPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    
    const showedPotWin = maxPaidPotentialWinning? maxPaidPotentialWinning : betslipContext.getPotentialWin();
    
    return <>
    	{
    		showAdvise && (
                <AdviceToReachBonusContainer bonusAdvice={betslipContext.toGetBonusAdvise.bonusAdvise} onClick={() => {appContext.toggleBetslip()}} />
	    		/* <div className="adviseToReachBonusContainer sportbook-footer" onClick={() => {appContext.toggleBetslip()}}>
					<span className={"iconContainer"}> <i className={"fas fa-gift"} /> </span>
					<span className={"textContainer"}>  {betslipContext.toGetBonusAdvise.bonusAdvise} </span> 
				</div> */
			)
    	}

        <div className="betslip-bottom-bar" onClick={() => {appContext.toggleBetslip()}}>
            <span className="ticket">
                <span>{couponKey}</span>
                <span className="triangle"></span>
            </span>
            {coupon.selectedContainer === 'singlebets' &&
                <>
                    <span className="details push-right">
                        <span className="details-name">{labels['betslip.bottom_bar.events_number']}</span>
                        <span className="details-value details__value_count">{betslipContext.getCouponSelectionsNum()}</span>
                    </span>
                    <span className="details">
                        <span className="details-name">{labels['betslip.bottom_bar.amount']}</span>
                        <span className="details-value">{getAmount(coupon)}</span>
                    </span>
                    <span className="details push-left">
                        <span className="details-name">{labels['betslip.bottom_bar.potential_winnings']}</span>
                        <span className="details-value">{showedPotWin}</span>
                    </span>
                </>
            }
            {coupon.selectedContainer === 'multibets' &&
                <>
                    <span className="details push-right">
                        <span className="details-name">{labels['betslip.bottom_bar.events_number']}</span>
                        <span className="details-value">{betslipContext.getCouponSelectionsNum()}</span>
                    </span>
                    <span className="details">
                        <span className="details-name">{labels['betslip.bottom_bar.total_odds']}</span>
                        <span className="details-value">{coupon.totalOdd}</span>
                    </span>
                    <span className="details">
                        <span className="details-name">{labels['betslip.bottom_bar.amount']}</span>
                        <span className="details-value">{getAmount(coupon)}</span>
                    </span>
                    <span className="details push-left">
                        <span className="details-name">{labels['betslip.bottom_bar.potential_winnings']}</span>
                        <span className="details-value">{showedPotWin}</span>
                    </span>
                </>
            }
            {coupon.selectedContainer === 'systembets' &&
                <span className="details-name push-left push-right">{labels['betslip.bottom_bar.system_available']}</span>
            }
        </div>
    </>
}

export default BetslipBottomBar;